import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PanelHeaderBar from 'components/PanelHeaderBar';
import { PANEL_SECTION_HEADER } from 'utils/constants/index';
import Section from 'components/Section';
import Label from 'components/Label';
import styles from '../index.module.scss';
import EditServices from './editServices';
import { connect } from 'react-redux';
import {
  getSecurityCompanyBillingInfo,
  getSecurityCompanyServices,
} from 'reducers/securityCompany';
import { getSupportedServices } from 'utils/DataTransform/SecurityCompanies/securityCompanyDetails.js';
import { isEmpty } from 'lodash';

const Services = ({ securityCompany, allServices, billingInfo }) => {
  const [showEditServicePanel, setShowEditServicePanel] = useState(false);
  const onEditService = () => {
    setShowEditServicePanel(true);
  };
  const closeEditServicePanel = () => {
    setShowEditServicePanel(false);
  };

  const havePaymentMethod = isEmpty(billingInfo)
    ? false
    : Boolean(billingInfo.paymentMethod.last4);

  const haveSubscriptions = allServices && allServices.length > 0;

  return (
    <>
      <div className={styles.infoPanel}>
        <PanelHeaderBar title={PANEL_SECTION_HEADER.SERVICES} />
        <Section
          text="Services Provided"
          editable={havePaymentMethod && haveSubscriptions}
          onEdit={onEditService}
          expandable={false}
          contentStyle={styles.sectionContent}
        >
          {havePaymentMethod &&
          haveSubscriptions &&
          !isEmpty(securityCompany.services) ? (
            <>
              <br />
              <div className={styles.subSectionContent}>
                <div className={styles.subSectionContent}>
                  <Label
                    className={styles.subSectionLabel}
                    label={'Available Services'}
                  />
                </div>
                {allServices
                  .filter(s => securityCompany.services.includes(s.id))
                  .map((s, key) => (
                    <Label
                      icon={s.icon}
                      alt={s.name}
                      label={s.name}
                      key={key}
                    />
                  ))}
              </div>
            </>
          ) : (
            <div className={styles.message}>
              {!havePaymentMethod ? (
                <>Please add a valid credit card to select services</>
              ) : (
                <>Please configure services</>
              )}
            </div>
          )}
        </Section>
      </div>
      {showEditServicePanel && (
        <EditServices
          securityCompany={securityCompany}
          close={closeEditServicePanel}
        />
      )}
    </>
  );
};

Services.propTypes = {
  securityCompany: PropTypes.object,
  allServices: PropTypes.array,
  billingInfo: PropTypes.object,
};

const mapStateToProps = state => ({
  allServices: getSupportedServices(getSecurityCompanyServices(state)),
  billingInfo: getSecurityCompanyBillingInfo(state),
  securityCompany: state.securityCompany,
});

export default connect(mapStateToProps, null)(Services);
